/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable semi */
// tierSelectionHandler.ts
import { DashboardFetch } from '../controllers/DashboardFetch';
import { TierItem } from '../GlobalDataContext';
import { HttpError } from './FetchBase';

const TIER_ERROR_OPEN_IN_FUTURE = 'You are not able to submit an application for this tier category as it is not open to accept applications at this stage. For information on when the tier category will open please visit <a href="https://www.austrade.gov.au/emdg" target="_blank">www.austrade.gov.au/emdg</a>';
const TIER_ERROR_CLOSED_ALREADY = 'You are no longer able to submit an application for this tier category as funding has been exhausted.';

interface TierSelectionHandlerParams {
    selectedTierValue: string;
    dashboardFetch: DashboardFetch;
    setState: (state: any, callback?: () => void) => void;
}

const tierActiveValidator = async ({
  selectedTierValue,
  dashboardFetch,
  setState,
}: TierSelectionHandlerParams): Promise<void> => {
  try {
    const tierSettingsArr: TierItem[] = await dashboardFetch.retrieveTierSettings();

    const selectedItem = tierSettingsArr.find((item) => item.tierValue.toString() === selectedTierValue);
    if (!selectedItem) {
      alert('Tier settings data is inconsistent. Cannot continue');
      return;
    }

    const currentDate = new Date();

    if (!selectedItem.openingDateUTC || !selectedItem.closingDateUTC) {
      setState({ tierErrorMessage: 'Opening / Closing dates are not defined correctly for this tier!' });
      return;
    }

    const openingDate = new Date(selectedItem.openingDateUTC);
    const closingDate = new Date(selectedItem.closingDateUTC);

    // Perform validation
    if (currentDate < openingDate) {
      // If current_date is before "openingDate", show error message A
      await new Promise<void>((resolve) => {
        setState({ tierErrorMessage: TIER_ERROR_OPEN_IN_FUTURE, tierSelectionIsValid: false }, resolve);
      });
    } else if (currentDate >= closingDate) {
      // If current_date is on or after "closingDate", show error message B
      await new Promise<void>((resolve) => {
        setState({ tierErrorMessage: TIER_ERROR_CLOSED_ALREADY, tierSelectionIsValid: false }, resolve);
      })
    } else {
      // If current_date falls within both "openingDate" and "closingDate", then don't show error
      await new Promise<void>((resolve) => {
        setState({ tierErrorMessage: null, tierSelectionIsValid: true }, resolve);
      })
    }
  } catch (error) {
    if (error instanceof HttpError) {
      console.error(`HTTP error occurred: ${error.status}`);
    } else {
      console.error(error);
    }
  }
};

export default tierActiveValidator;
